export default __webpack_public_path__ + "static/media/hrc.b1196b50.png";